import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss',
    '../customer-authentication.component.scss',
    '../../../../../../../node_modules/daemonite-material/css/material.min.css'
  ]
})
export class LoginComponent implements OnInit {

  @Output() signInBtnClicked = new EventEmitter();

  login:string;
  password:string;

  
  constructor() { }

  ngOnInit() { }

  signIn(){
    this.signInBtnClicked.emit({usr:this.login, pass:this.password})
  }
}
